<div class="jumbotron">
    <h1 class="display-4">Sorry</h1>
    <p class="lead">Your page you are looing for is invalid.</p>
    <hr class="my-4">
    <button class="btn btn-primary btn-lg" (click)="gotoHome()">Back to Select consultation</button>
  </div>